import { Dialog } from '@economic/taco';
import { useCurrentAgreement } from '@economic/react-app';
import React from 'react';

import { PlanUpgradeDialog } from '~/company-feature';

/**
 * Ensure that if the trial expires we greet customer with forced upgrade.
 */
export default function UpgradeExpiredTrialDialog() {
    const agreement = useCurrentAgreement();

    const isTrialExpired = agreement.subscription.trial?.expiryDate
        ? new Date(agreement.subscription.trial.expiryDate).getTime() < Date.now()
        : false;

    if (!isTrialExpired) {
        return null;
    }

    return (
        <Dialog defaultOpen size="lg" showCloseButton={false} closeOnEscape={false}>
            <Dialog.Content aria-label="">{({ close }) => <PlanUpgradeDialog onHide={close} />}</Dialog.Content>
        </Dialog>
    );
}
